module.exports = __webpack_public_path__ + "static/media/rss24group.d8ffbc3a.jpeg";